export default __webpack_public_path__ + "static/home-sugar-free-salted-caramel-ice-cream-47b799584b85723b248f2e638e3ddbea.png";